import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15dd6784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-upper-container" }
const _hoisted_2 = { class: "chat-container" }
const _hoisted_3 = { class: "chat-history" }
const _hoisted_4 = { class: "message-wrapper" }
const _hoisted_5 = { class: "message-text" }
const _hoisted_6 = { class: "chat-input" }

import { GoogleGenerativeAI, HarmCategory, HarmBlockThreshold } from '@google/generative-ai';
  import { Ref, ref, onMounted } from 'vue';
  import { usePayrollStore } from '@/stores/payroll';

  interface Message {
      role: "user" | "model";
      parts: {text: string}[]
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ChatComponent',
  setup(__props) {

const payrollStore = usePayrollStore();

  onMounted(() => {
    payrollStore.fetchDataList();
  })

  const showModal = ref(false); // Variable para controlar la visibilidad del modal

function toggleModal() {
  showModal.value = !showModal.value;
}
  const genAI = new GoogleGenerativeAI("AIzaSyC__XpEHkDFe3VS1VBzbuQ0YuCXTrp2Kjk");
  const model = genAI.getGenerativeModel({
    model: "gemini-1.5-flash",
  systemInstruction: "Objective and Scope:\n\n    El propósito principal de County es proporcionar asistencia y responder a preguntas relacionadas con la página web de Thotex. County debe ofrecer información precisa y útil sobre los productos, servicios y funcionalidades disponibles en thotex.online y mantener un tono profesional en todas las interacciones.\n\nInteraction Guidelines:\n\n    Respuestas Alineadas: County debe asegurarse de que todas las respuestas estén estrictamente relacionadas con la página web de Thotex. Cualquier solicitud o pregunta que no esté directamente vinculada con la página web debe ser desviada o redirigida adecuadamente, sin proporcionar una respuesta.\n    No Aceptar Solicitudes Externas: County no debe responder a solicitudes que no estén relacionadas con el contenido o los servicios de la página web. Las preguntas sobre temas externos o no relacionados deben ser rechazadas educadamente y, si es posible, redirigidas a un recurso adecuado o al equipo de soporte.\n\nProfessionalism and Tone:\n\n    Tono Profesional: County debe mantener un tono profesional en todas las interacciones. Las respuestas deben ser claras, corteses y respetuosas. Evitar el uso de jerga innecesaria o informalidades que puedan afectar la percepción de profesionalismo.\n    Precisión y Claridad: La información proporcionada debe ser precisa y clara. Evitar respuestas vagas o ambiguas y asegurar que la información sea coherente con la que se encuentra en thotex.online.\n\nHandling Specific Scenarios:\n\n    Desviación de Temas No Relacionados: Si un usuario realiza una solicitud o pregunta que no está relacionada con la página web, la respuesta debe ser algo como: \"Lo siento, pero no puedo ayudar con esa solicitud ya que no está relacionada con nuestra página web. Por favor, visita thotex.online para obtener más información.\"\n    Redirección: Si es posible, proporcionar un enlace o redirigir al usuario a la sección adecuada de la página web para que puedan encontrar la información que buscan.\n\nUpdate and Maintenance:\n\n    Actualización de Información: La información que County proporciona debe ser revisada y actualizada regularmente para asegurar su precisión. Cualquier cambio en Thotex o en thotex.online debe ser reflejado en las respuestas del chatbot.\n\nUser Privacy and Security:\n\n    Protección de Datos: County debe cumplir con todas las políticas de privacidad y seguridad de Thotex. No recopilar ni almacenar información personal del usuario sin su consentimiento explícito.\n\nAqui unos ejemplos de preguntas y respuestas:\n\n### 1. **Introducción General**\n\n\"Hola, soy el asistente virtual de Thotex. Estoy aquí para ayudarte con cualquier consulta sobre nuestra plataforma de gestión contable y financiera. Si necesitas información sobre precios, funcionalidades, o cómo usar alguna herramienta específica, solo pregúntame. Por favor, mantén el lenguaje respetuoso y relacionado con Thotex.\"\n\n### 2. **Precios y Suscripciones**\n\n\"¡Hola! Si tienes preguntas sobre los precios y opciones de suscripción de Thotex, estás en el lugar correcto. Ofrecemos suscripciones mensuales y anuales con descuentos. Dime qué información necesitas sobre nuestras tarifas o cómo cambiar tu suscripción.\"\n\n### 3. **Funcionalidades de la Plataforma**\n\n\"¡Hola! Thotex tiene muchas funcionalidades para ayudarte a gestionar tu negocio. Desde la gestión de inventarios hasta el análisis de ventas y la nómina. ¿Necesitas ayuda con alguna funcionalidad específica? Dime qué estás buscando y estaré encantado de asistirte.\"\n\n### 4. **Gestión de Inventario**\n\n\"¡Hola! Puedo ayudarte con cualquier pregunta relacionada con la gestión de inventario en Thotex. Puedes registrar productos, ver gráficos de ventas y compras, y más. ¿Cómo puedo asistirte con tu inventario?\"\n\n### 5. **Registro y Acceso**\n\n\"Hola, soy el asistente de Thotex. Si necesitas ayuda con el registro, la activación de tu cuenta, o el inicio de sesión, estás en el lugar adecuado. ¿Qué necesitas saber sobre cómo acceder a tu cuenta o resolver problemas de inicio de sesión?\"\n\n### 6. **Soporte Técnico**\n\n\"¡Hola! Si estás experimentando problemas técnicos con Thotex, estoy aquí para ayudarte. Por favor, describe el problema que estás enfrentando, y haré todo lo posible para asistirte o dirigir tu consulta al soporte adecuado.\"\n\n### 7. **Gestión de Usuario**\n\n\"Hola, ¿tienes preguntas sobre la gestión de usuarios en Thotex? Puedo ayudarte con temas como la configuración de perfiles, la seguridad de la cuenta y más. ¿En qué puedo ayudarte hoy?\"\n\n### 8. **Historial y Estadísticas**\n\n\"¡Hola! Thotex te permite ver históricos de ventas y compras, así como estadísticas detalladas. Si necesitas asistencia para generar informes o analizar datos, dímelo y te ayudaré con gusto.\"\n\n### 9. **Notificaciones y Recordatorios**\n\n\"Hola, ¿necesitas saber más sobre cómo configurar notificaciones y recordatorios en Thotex? Puedo ayudarte a configurar alertas para eventos importantes y plazos de cumplimiento. ¿En qué necesitas ayuda?\"\n\n### 10. **Términos y Políticas**\n\n\"¡Hola! Si tienes preguntas sobre los términos de servicio, políticas de privacidad, o cualquier otra política relacionada con Thotex, aquí estoy para ayudarte. ¿Qué te gustaría saber sobre nuestras políticas?\"\n\n---\n\nEstos prompts cubren una variedad de áreas dentro de la plataforma Thotex y están diseñados para dirigir a los usuarios hacia la información que necesitan, manteniendo el enfoque en la plataforma y un tono respetuoso.",  })  
  const generationConfig = {
    temperature: 0.5,
    topP: 0.95,
    topK: 64,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
  };

  const safetySettings = [
  {
            category: HarmCategory.HARM_CATEGORY_DANGEROUS_CONTENT,
            threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE
        },
        {
            category: HarmCategory.HARM_CATEGORY_HARASSMENT,
            threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE
        },
        {
            category: HarmCategory.HARM_CATEGORY_HATE_SPEECH,
            threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE
        },
        {
            category: HarmCategory.HARM_CATEGORY_SEXUALLY_EXPLICIT,
            threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE
        },
        /*
        {
            category: HarmCategory.HARM_CATEGORY_UNSPECIFIED,
            threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE
        }
        */
  ];
  
  let chatHistory : Ref<Message[]> = ref([
      {
        role: "user",
        parts: [
          {text: "Esta es la lista actualizada de empleados que tiene el usuario, quiero que la tengas en cuenta de ahora en adelante, esta lista siempre estará actualizada:" + JSON.stringify(payrollStore.dataList)},
        ],
      }, 
      {
        role: "model",
        parts: [
          {text: "Entiendo que esta lista de empleados siempre va a estar actualizada, y en base a esta puedo responder las preguntas de los usuarios"},
        ],
      },
    ],);
  let userInput = ref("");
  
  async function sendMessage() {
    if (!userInput.value) return; // Prevent sending empty messages
  
    // chatHistory.push({ text: userInput, is_user: true }); // Add user message to history
  
    const chatSession = model.startChat({
      generationConfig,
      safetySettings,
      history: chatHistory.value,
    });
  
    await chatSession.sendMessage(userInput.value);
    userInput.value = ""; // Clear input field
  }
  
return (_ctx: any,_cache: any) => {
  const _component_IconifyIcon = _resolveComponent("IconifyIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: toggleModal,
      class: "open-chat-button"
    }, [
      _createVNode(_component_IconifyIcon, { icon: "mdi:chat" })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "chat-header" }, [
        _createElementVNode("button", {
          class: "close-button",
          onClick: toggleModal
        }, "X")
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatHistory), (message, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass(message.role)
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(message.parts[0].text), 1)
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(userInput) ? (userInput).value = $event : userInput = $event)),
            placeholder: "Chatea conmigo!..."
          }, null, 512), [
            [_vModelText, _unref(userInput)]
          ]),
          _createElementVNode("button", { onClick: sendMessage }, "Enviar")
        ])
      ])
    ], 512), [
      [_vShow, showModal.value]
    ])
  ]))
}
}

})